module.exports = "../study/imgs/maps/Kanagawa/S8/Helth/HeatDisorder/Kanagawa_HeatDisorder_MIROC5_RCP26_End.png";